import { render, staticRenderFns } from "./DocumentsAndAtasForm.vue?vue&type=template&id=52757c19&scoped=true"
import script from "./DocumentsAndAtasForm.vue?vue&type=script&lang=js"
export * from "./DocumentsAndAtasForm.vue?vue&type=script&lang=js"
import style0 from "./DocumentsAndAtasForm.vue?vue&type=style&index=0&id=52757c19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52757c19",
  null
  
)

export default component.exports